var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_384",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29223",
    "data-name": "Group 29223",
    transform: "translate(211 10575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -211, -10575)",
    filter: "url(#Ellipse_384)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384-2",
    "data-name": "Ellipse 384",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_15_",
    "data-name": "svgexport-17 (15)",
    transform: "translate(-218.455 -10695.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50536",
    "data-name": "Path 50536",
    d: "M395.441,280h-2.753a.688.688,0,0,0-.688.688v6.881a.688.688,0,0,0,.688.688h2.753a4.129,4.129,0,1,0,0-8.257Z",
    transform: "translate(-336.347 -124.302)",
    fill: "#445496"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_511",
    "data-name": "Ellipse 511",
    cx: 4.789,
    cy: 4.789,
    r: 4.789,
    transform: "translate(51.539 154.776)",
    fill: "#2c3e91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50537",
    "data-name": "Path 50537",
    d: "M108.643,280h-2.752a.688.688,0,0,0-.688.688v6.881a.688.688,0,0,0,.688.688h2.752a4.129,4.129,0,1,0,0-8.257Zm-17.2,0H88.688a.688.688,0,0,0-.688.688v6.881a.688.688,0,0,0,.688.688h2.752a4.129,4.129,0,1,0,0-8.257Z",
    transform: "translate(-58.495 -124.302)",
    fill: "#445496"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50538",
    "data-name": "Path 50538",
    d: "M63.911,152.945v5.5a1.376,1.376,0,0,1-1.376,1.376H26.752A2.753,2.753,0,0,1,24,157.075v-7.4a2.065,2.065,0,0,1,.6-1.459l3-3A4.129,4.129,0,0,1,30.527,144H47.134a6.2,6.2,0,0,1,4.078,1.532l3.754,3.285h4.817a4.124,4.124,0,0,1,4.129,4.129Z",
    transform: "translate(0 0)",
    fill: "#5771e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50539",
    "data-name": "Path 50539",
    d: "M349.074,204.129v5.5a1.376,1.376,0,0,1-1.376,1.376h-8.946a1.376,1.376,0,0,0,1.376-1.376v-5.5A4.129,4.129,0,0,0,336,200h8.945a4.124,4.124,0,0,1,4.129,4.129Z",
    transform: "translate(-285.163 -51.183)",
    fill: "#6e8beb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50540",
    "data-name": "Path 50540",
    d: "M63.911,259.44v1.376a1.376,1.376,0,0,1-1.376,1.376H26.752A2.753,2.753,0,0,1,24,259.44h.688l1.033-1.291a5.726,5.726,0,0,1,8.944,0L35.7,259.44h6.193l1.033-1.291a5.726,5.726,0,0,1,8.944,0L52.9,259.44Z",
    transform: "translate(0 -102.365)",
    fill: "#89a8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50541",
    "data-name": "Path 50541",
    d: "M98.837,148.817H72L75.441,144H91a6.2,6.2,0,0,1,4.078,1.532Z",
    transform: "translate(-43.871 0)",
    fill: "#96cffa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50542",
    "data-name": "Path 50542",
    d: "M213.039,148.817h-8.257l-3.754-3.285A6.2,6.2,0,0,0,196.95,144h8.257a6.2,6.2,0,0,1,4.078,1.532Z",
    transform: "translate(-158.074 0)",
    fill: "#c4e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50543",
    "data-name": "Path 50543",
    d: "M176,296h1.376v2.752H176Z",
    transform: "translate(-138.926 -138.926)",
    fill: "#6e8beb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50544",
    "data-name": "Path 50544",
    d: "M155.441,208.257h-1.376v-1.779l-1.863-1.863a.688.688,0,0,1-.2-.487V200h1.376v3.844l1.863,1.863a.688.688,0,0,1,.2.487Z",
    transform: "translate(-116.99 -51.183)",
    fill: "#4356e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50545",
    "data-name": "Path 50545",
    d: "M152,144h1.376v4.817H152Z",
    transform: "translate(-116.99 0)",
    fill: "#7ab8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50546",
    "data-name": "Path 50546",
    d: "M24,224h2.752l-1.376,2.064H24Z",
    transform: "translate(0 -73.119)",
    fill: "#f28868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50547",
    "data-name": "Path 50547",
    d: "M192,232h2.064v1.376H192Z",
    transform: "translate(-153.55 -80.431)",
    fill: "#4356e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_512",
    "data-name": "Ellipse 512",
    cx: 3.592,
    cy: 3.592,
    r: 3.592,
    transform: "translate(26.395 155.974)",
    fill: "#e4e9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50548",
    "data-name": "Path 50548",
    d: "M52.129,288.257a4.129,4.129,0,1,1,4.129-4.129A4.129,4.129,0,0,1,52.129,288.257Zm0-6.881a2.752,2.752,0,1,0,2.752,2.752A2.752,2.752,0,0,0,52.129,281.376Z",
    transform: "translate(-21.936 -124.302)",
    fill: "#56679c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50549",
    "data-name": "Path 50549",
    d: "M378.322,296v1.376a1.376,1.376,0,0,1-1.376,1.376H368a1.376,1.376,0,0,0,1.376-1.376V296Z",
    transform: "translate(-314.411 -138.926)",
    fill: "#a2c1fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50550",
    "data-name": "Path 50550",
    d: "M371.01,233.376v1.376h-8.945A2.065,2.065,0,0,1,360,232.688V232h10.775A4.118,4.118,0,0,1,371.01,233.376Z",
    transform: "translate(-307.099 -80.431)",
    fill: "#89a8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50551",
    "data-name": "Path 50551",
    d: "M363.441,234.752h-1.376A2.064,2.064,0,0,1,360,232.688V232h3.441Z",
    transform: "translate(-307.099 -80.431)",
    fill: "#a2c1fa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_513",
    "data-name": "Ellipse 513",
    cx: 1.197,
    cy: 1.197,
    r: 1.197,
    transform: "translate(28.789 158.368)",
    fill: "#cad8ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_514",
    "data-name": "Ellipse 514",
    cx: 3.592,
    cy: 3.592,
    r: 3.592,
    transform: "translate(44.355 155.974)",
    fill: "#e4e9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50552",
    "data-name": "Path 50552",
    d: "M252.129,288.257a4.129,4.129,0,1,1,4.129-4.129A4.129,4.129,0,0,1,252.129,288.257Zm0-6.881a2.752,2.752,0,1,0,2.752,2.752A2.752,2.752,0,0,0,252.129,281.376Z",
    transform: "translate(-204.733 -124.302)",
    fill: "#56679c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_515",
    "data-name": "Ellipse 515",
    cx: 0.599,
    cy: 1.197,
    rx: 0.599,
    ry: 1.197,
    transform: "translate(46.75 158.368)",
    fill: "#cad8ed"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuv);
export default __webpack_public_path__ + "static/media/SUV.769733b8a29918f463f2723c943a4f05.svg";
export { ForwardRef as ReactComponent };